
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/namigi",
      function () {
        return require("private-next-pages/namigi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/namigi"])
      });
    }
  